export default "__VITE_ASSET__DVxam0Qr__"